var map = {
	"./de.png": "./src/assets/post/nutrition/de.png",
	"./en.png": "./src/assets/post/nutrition/en.png",
	"./en2.png": "./src/assets/post/nutrition/en2.png",
	"./es.png": "./src/assets/post/nutrition/es.png",
	"./fr.png": "./src/assets/post/nutrition/fr.png",
	"./it.png": "./src/assets/post/nutrition/it.png",
	"./pt.png": "./src/assets/post/nutrition/pt.png",
	"./ru.png": "./src/assets/post/nutrition/ru.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/post/nutrition sync recursive ^\\.\\/.*\\.png$";